import { render, staticRenderFns } from "./order.vue?vue&type=template&id=feeae512&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feeae512')) {
      api.createRecord('feeae512', component.options)
    } else {
      api.reload('feeae512', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=feeae512&", function () {
      api.rerender('feeae512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provide/customerOrder/order.vue"
export default component.exports